/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable import/extensions */
/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';

import useTimeline from '../timeline/useTimeline';
import NonPatientActivity from './Activities/NonPatientActivity';
import LunchActivity from './Activities/LunchActivity';
import PatientActivity from './Activities/PatientActivity';

import _ from '../../../utils/lodash';
import globals from '../../../globals/communityGlobals';
import { AssignmentType } from '../../../enums/assignmentType';
import { AssignmentVisitState } from '../../../enums/assignmentVisitState';
import { addDateTimeMinutes, parseDateUtc } from '../../../utils/dates';
import {
  addClassToElements,
  findByAttrDataIdAndHandleActiveClass,
  resetTimelineActiveClass,
} from '../timeline/timelineHelper';
import {
  getAvailableTimeSpansForTreatment,
  GetAvailableTimeSpansForLunchBreak,
  postAssignClinicianToTreatment,
  postRescheduleClinicianAssignment,
  postUpdateLunchBreak,
  postUnassignClinicianFromTreatmentInstance,
  postAssignClinicianToMultipleTreatments,
} from '../../../actions/areas/planner';

/* eslint-disable react/jsx-no-undef */
export default function ClinicianActivities({
  activities,
  isAdvanceFilterActive,
  filteredAssignments,
  shouldFilterAssignments,
  schedulerPeriod,
  baseRequestModel,
  clinicianIds,
  onActionClick,
  isMileageCapEnabled,
  isActionRunning,
  setIsActionRunning,
  isMultiAssign,
  setIsMultiAssign,
  setTimelineDialog,
}) {
  const {
    setActiveAssignment,
    hasAvailableTimeSpansForClinicianId,
    getAvailableTimeSpans,
    getFlag,
    setAvailableTimeSpans,
    getParamsForAssignment,
    getAccessToken,
    resetContext,
    getAssignmentForEdit,
    activeClinicianId,
    setActiveNonPatientAssignment,
    setAlertMessage,
    getMultiSelectedTreatments,
  } = useTimeline();
  const isPast = parseDateUtc(schedulerPeriod.startDate).isBefore(parseDateUtc(globals.now), 'day');
  const isEditMode = !isPast && getFlag('isEditMode');
  const showTravelTime = getFlag('showTravelTime');
  const currentTime = globals.now;

  const highlightItem = itemId => {
    addClassToElements('timeline-rows-container', 'active-overlay');
    findByAttrDataIdAndHandleActiveClass('timeline-rows-container', '.timeline-assignment', itemId);
  };

  const resetAndReloadError = message => {
    setIsActionRunning(false);
    setAlertMessage(message);
  };

  const resetAndReload = () => {
    setIsActionRunning(false);
    resetContext();
    onActionClick();
  };

  const assignmentClick = assignment => {
    if (assignment.id !== 0) {
      setActiveAssignment(assignment);
    }
  };

  const assignmentClickEditMode = assignment => {
    if (assignment.id !== 0) {
      highlightItem(assignment.id);

      const assignmentParams = {
        ClinicianIds: clinicianIds,
        TreatmentId: assignment.treatmentId,
        TreatmentInstanceId: assignment.treatmentInstanceId,
        TimeSlotId: assignment.timeSlotId,
        AssignmentId: assignment.id,
      };
      const model = _.merge(assignmentParams, baseRequestModel);
      if (isMultiAssign) {
        setIsMultiAssign(false);
      }
      getAvailableTimeSpansForTreatment(getAccessToken, model, false, response => {
        resetTimelineActiveClass('timeline-rows-container', 'timeline-assignment');
        setAvailableTimeSpans(response, assignment);
      });

      setTimeout(() => resetTimelineActiveClass('timeline-rows-container', 'timeline-assignment'), 10000);
    }
  };

  const lunchBreakClickEditMode = assignment => {
    highlightItem(assignment.id);

    const assignmentParams = {
      ClinicianId: assignment.clinicianId,
      PostingId: assignment.postingId,
      AvailabilityId: assignment.availabilityId,
    };
    const model = _.merge(assignmentParams, baseRequestModel);
    GetAvailableTimeSpansForLunchBreak(getAccessToken, model, false, response => {
      resetTimelineActiveClass('timeline-rows-container', 'timeline-assignment');
      setAvailableTimeSpans(response, assignment);
    });

    setTimeout(() => resetTimelineActiveClass('timeline-rows-container', 'timeline-assignment'), 10000);
  };

  const handleAssignmentClick = (assignment, isPlannedVisit) => {
    return isEditMode ? (isPlannedVisit ? assignmentClickEditMode(assignment) : null) : assignmentClick(assignment);
  };

  const handleLunchBreakClick = assignment => (isEditMode ? lunchBreakClickEditMode(assignment) : null);

  const getClinicianAvailability = (clinicianAvailability, cellStartTime) => {
    return clinicianAvailability !== undefined
      ? _.find(_.orderBy(clinicianAvailability.timeSpans, item => item.isAssignablePeriod, 'desc'), item =>
          parseDateUtc(cellStartTime).isBetween(parseDateUtc(item.start), parseDateUtc(item.end), null, '[]'),
        )
      : undefined;
  };

  const getActiveTreatmentTimeSpan = (clinicianId, postingId, cellStartTime) => {
    const clinicianAvailability = _.find(
      getAvailableTimeSpans(),
      x => x.clinicianId === clinicianId && x.postingId === postingId,
    );

    return getClinicianAvailability(clinicianAvailability, cellStartTime);
  };

  const getActiveTreatmentsTimeSpan = (clinicianId, postingId, cellStartTime) => {
    const availableTimeSpans = getAvailableTimeSpans().clinicianTimeSpans;
    const clinicianAvailability =
      availableTimeSpans !== undefined
        ? availableTimeSpans.find(x => x.clinicianId === clinicianId && x.postingId === postingId)
        : undefined;

    return getClinicianAvailability(clinicianAvailability, cellStartTime);
  };

  const nonPatientActivityClick = assignment => {
    if (assignment.nonPatientActivityId !== 0) {
      setActiveNonPatientAssignment(assignment);
    }
  };

  const availabilityPlaceholderRender = (availability, clinicianId, postingId) => {
    const availabilityStartDate = availability.visual.startDate;
    const availabilityDuration = availability.visual.duration;

    const cells = [];
    const numberOfCells = availabilityDuration / schedulerPeriod.cellLength;

    const assignClinicianToTreatment = cellStartTime => {
      const assignmentParams = getParamsForAssignment();
      const model = _.merge(assignmentParams, baseRequestModel, {
        assignmentTime: cellStartTime,
        postingId: availability.postingId,
      });

      setIsActionRunning(true);
      postAssignClinicianToTreatment(getAccessToken, model, resetAndReload, resetAndReloadError);
    };

    const rescheduleClinicianAssignment = cellStartTime => {
      setIsActionRunning(true);
      if (getAssignmentForEdit.assignmentType === AssignmentType.LunchBreak) {
        const model = {
          availabilityId: getAssignmentForEdit.availabilityId,
          restNewStartDate: cellStartTime,
        };

        postUpdateLunchBreak(getAccessToken, model, resetAndReload, resetAndReloadError);
      } else {
        const model = {
          assignGuid: getAssignmentForEdit.assignGuid,
          newAssignmentTime: cellStartTime,
          postingId: availability.postingId,
          oldPostingId: getAssignmentForEdit.postingId,
        };

        postRescheduleClinicianAssignment(getAccessToken, model, resetAndReload, resetAndReloadError);
      }
    };

    const assignMultipleTreatmentInstances = cellStartTime => {
      const selectedTreatments = getMultiSelectedTreatments;

      if (!selectedTreatments && !selectedTreatments.length) {
        return;
      }

      const model = {};
      model.orgUnitId = baseRequestModel.OrgUnitId;
      model.selectedDate = baseRequestModel.SelectedDate;
      model.postingId = postingId;
      model.selectedStartingAssignmentTime = cellStartTime;
      model.treatmentsTreatmentInstancesIds = selectedTreatments.map((treatment, index) => {
        return {
          treatmentId: treatment.treatmentId,
          treatmentInstanceId: treatment.treatmentInstanceId,
          timeSlotId: treatment.timeSlotId,
          selectedIndex: index + 1,
        };
      });

      setIsActionRunning(true);

      const onSuccess = response => {
        const hasValidationErrors = response.data && response.data.errors && !!response.data.errors.length;
        if (hasValidationErrors) {
          const bodyContent = response.data.errors.map(error => <p>{error}</p>);
          setTimelineDialog({ content: bodyContent, refreshOnClose: true });
          setIsActionRunning(false);
          resetContext();
        } else {
          resetAndReload();
        }

        setIsMultiAssign(false);
      };

      postAssignClinicianToMultipleTreatments(getAccessToken, model, onSuccess, resetAndReloadError);
    };

    const assignToClinician = cellStartTime => {
      if (isMultiAssign) {
        assignMultipleTreatmentInstances(cellStartTime);
        return;
      }
      assignClinicianToTreatment(cellStartTime);
    };

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < numberOfCells; i++) {
      const cellStartTime = addDateTimeMinutes(availabilityStartDate, i * schedulerPeriod.cellLength);
      const activeTreatmentTimeSpan = isMultiAssign
        ? getActiveTreatmentsTimeSpan(clinicianId, postingId, cellStartTime)
        : getActiveTreatmentTimeSpan(clinicianId, postingId, cellStartTime);
      const hasAvailabilityCell = activeTreatmentTimeSpan !== undefined && !isActionRunning;
      const isNonAssignable = hasAvailabilityCell && activeTreatmentTimeSpan !== undefined;

      const containerClass = classNames({
        'timeline-act-tab': true,
        'timeline-availability-placeholder': true,
        available: hasAvailabilityCell,
        'non-assignable': isNonAssignable ? !activeTreatmentTimeSpan.isAssignablePeriod : false,
      });

      const activeCellClickHandler = () => {
        if (!hasAvailabilityCell || !activeTreatmentTimeSpan.isAssignablePeriod) return;

        if (isEditMode) {
          rescheduleClinicianAssignment(cellStartTime);
        } else {
          assignToClinician(cellStartTime);
        }
      };

      cells.push(
        <div
          key={`cell_${availability.index}_${i}`}
          className={containerClass}
          data-start-datetime={cellStartTime}
          data-duration={schedulerPeriod.cellLength}
          onClick={activeCellClickHandler}
        >
          &nbsp;
        </div>,
      );
    }
    return cells;
  };

  const clinicianAvailabilitiesRender = (availability, clinicianId, postingId) => {
    return (
      <div
        key={`availability_${availability.index}`}
        className="timeline-availability-wrapper"
        data-start-datetime={availability.visual.startDate}
      >
        {availabilityPlaceholderRender(availability, clinicianId, postingId)}
      </div>
    );
  };

  const clinicianAssignmentRender = (assignment, isClinicianRowActive) => {
    const isPatientAssignment = assignment.assignmentType === AssignmentType.PatientAssignment;
    const flags = {
      isLunchAssignment: assignment.assignmentType === AssignmentType.LunchBreak,
      isNonPatientAssignment: assignment.assignmentType === AssignmentType.NonPatientAssignment,
      isPatientAssignment,
      isPlannedVisit: isPatientAssignment && assignment.visitStatus === AssignmentVisitState.Planned,
      isCompletedVisit: isPatientAssignment && assignment.visitStatus === AssignmentVisitState.Complete,
      isAhead: isPatientAssignment && assignment.visitStatus === AssignmentVisitState.Ahead,
      isStartedLate: isPatientAssignment && assignment.visitStatus === AssignmentVisitState.StartedLate,
      isBehindNow: parseDateUtc(assignment.visitTime.actual.startDate).isBefore(parseDateUtc(currentTime)),
      isClinicianRowActive,
      showTravelTime,
      isEditMode,
      isOutsideOfMileageCap: isMileageCapEnabled && assignment.outsideOfMileageCap,
      isBundled: assignment.isBundled,
    };

    const isFiltered =
      isAdvanceFilterActive &&
      (shouldFilterAssignments ? !filteredAssignments.some(a => a.id === assignment.id) : true);

    const isSelecteableAssignment =
      activeClinicianId !== null
        ? isClinicianRowActive
          ? isPatientAssignment || flags.isLunchAssignment || flags.isNonPatientAssignment || flags.isBehindNow
          : false
        : isPatientAssignment || flags.isLunchAssignment || flags.isNonPatientAssignment || flags.isBehindNow;

    const containerClass = classNames('timeline-act-tab', 'timeline-assignment', 'initial-render', {
      selectable: isSelecteableAssignment,
      'is-behind-now': flags.isBehindNow,
      'overlap-visit': isPatientAssignment && assignment.overlapsPeriodStart,
      'visit-planned-red': flags.isPlannedVisit && assignment.cardStatus.name.toLowerCase() === 'red',
      'visit-planned-amber': flags.isPlannedVisit && assignment.cardStatus.name.toLowerCase() === 'amber',
      'visit-planned-green': flags.isPlannedVisit && assignment.cardStatus.name.toLowerCase() === 'green',
      'visit-complete': flags.isCompletedVisit,
      'visit-ahead':
        isPatientAssignment &&
        (assignment.visitStatus === AssignmentVisitState.OnTime ||
          assignment.visitStatus === AssignmentVisitState.StartedLate ||
          flags.isAhead),
      // 'visit-ontime': isPatientAssignment && assignment.visitStatus === AssignmentVisitState.OnTime, -- removed green color due to introducing started late, every started visit is blue
      'visit-behind': isPatientAssignment && assignment.visitStatus === AssignmentVisitState.Behind,
      'lunch-assignment': flags.isLunchAssignment,
      'non-patient-assignment': flags.isNonPatientAssignment,
      'edit-mode': flags.isEditMode && (flags.isPlannedVisit || flags.isLunchAssignment || flags.isBehindNow),
      'rag-status': isPatientAssignment,
      'rag-status-red': isPatientAssignment && assignment.ragStatus.name.toLowerCase() === 'red',
      'rag-status-amber': isPatientAssignment && assignment.ragStatus.name.toLowerCase() === 'amber',
      'rag-status-green': isPatientAssignment && assignment.ragStatus.name.toLowerCase() === 'green',
      'rag-status-yellow': isPatientAssignment && assignment.ragStatus.name.toLowerCase() === 'yellow',
      'is-lunch-overlap': assignment.isLunchBreakOverlap,
      'is-copy':
        assignment.cardType.toLowerCase() === 'additionalclinician' ||
        assignment.cardType.toLowerCase() === 'overriddenclinician',
    });

    return (
      <React.Fragment key={`assignment-container-${assignment.index}`}>
        {flags.isLunchAssignment && (
          <LunchActivity
            assignment={assignment}
            containerClass={containerClass}
            handleAssignmentFunc={handleLunchBreakClick}
          />
        )}
        {flags.isNonPatientAssignment && (
          <NonPatientActivity
            assignment={assignment}
            containerClass={containerClass}
            schedulerPeriod={schedulerPeriod}
            flags={flags}
            handleNonPatientActivityClick={nonPatientActivityClick}
          />
        )}
        {flags.isPatientAssignment && (
          <PatientActivity
            assignment={assignment}
            isFiltered={isFiltered}
            containerClass={containerClass}
            schedulerPeriod={schedulerPeriod}
            flags={flags}
            handleAssignmentFunc={isSelecteableAssignment ? handleAssignmentClick : () => {}}
            unAssignClinicianFunc={() =>
              isSelecteableAssignment
                ? postUnassignClinicianFromTreatmentInstance(
                    getAccessToken,
                    { id: assignment.id },
                    resetAndReload,
                    setAlertMessage,
                  )
                : () => {}
            }
          />
        )}
      </React.Fragment>
    );
  };

  const { clinicianId, postingId, availabilities, assignments } = activities;
  const isClinicianRowActive = hasAvailableTimeSpansForClinicianId(clinicianId, postingId);

  if (activeClinicianId === null) resetTimelineActiveClass('timeline-rows-container');
  if (isClinicianRowActive) addClassToElements('timeline-rows-container', 'active-overlay');
  const group50Assignments = _.filter(assignments, x => x.overlapGroupIndex >= 1 && x.overlapGroupIndex <= 2);
  const group33Assignments = _.filter(assignments, x => x.overlapGroupIndex >= 3);
  const singleAssignments = _.filter(assignments, x => x.overlapGroupIndex === 0);

  return (
    <div key={`clinician-${clinicianId}`} className={`timeline-act-row${isClinicianRowActive ? ' highlight-row' : ''}`}>
      {availabilities.map(availability =>
        clinicianAvailabilitiesRender(availability, clinicianId, postingId, isClinicianRowActive),
      )}
      {singleAssignments.map(assignment => clinicianAssignmentRender(assignment, isClinicianRowActive))}
      {group50Assignments.length > 0 && (
        <div className="group50-assignments-wraper">
          {group50Assignments.map(assignment => clinicianAssignmentRender(assignment, isClinicianRowActive))}
        </div>
      )}
      {group33Assignments.length > 0 && (
        <div className="group33-assignments-wraper">
          {group33Assignments.map(assignment => clinicianAssignmentRender(assignment, isClinicianRowActive))}
        </div>
      )}
    </div>
  );
}
